// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"3cb2f677","131":"ef77a943","238":"3cb2f677","245":"3cb2f677","474":"6b4debd1","507":"1233265e","773":"dac4869d"}[chunkId] + ".chunk.css";
};